import { render, staticRenderFns } from "./SelectSemester.vue?vue&type=template&id=773ad97e&"
import script from "./SelectSemester.vue?vue&type=script&lang=js&"
export * from "./SelectSemester.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports